import React from "react";
import { ListaPlantillas } from "./ListaPlantillas";
import { Plantilla } from "./Plantilla";
import {
  PlantillaCorreoMasivoResumida,
  useLeerListaClientes,
  useLeerPlantillas,
} from "../../../services/correosMasivosServicios";
import LoadingScreen from "../../organisms/LoadingScreen";
import { NuevoCorreoMasivo } from "./NuevoCorreoMasivo";
import { Button } from "react-bootstrap";
import AddIcon from "@mui/icons-material/Add";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { useNavigate, useParams } from "react-router-dom";

export const CorreosMasivosLayout = (_: {}) => {
  const nagivate = useNavigate();
  const { idPlantilla } = useParams();

  const {
    data: plantillas,
    isLoading: plantillasIsLoading,
    isError: plantillasIsError,
  } = useLeerPlantillas();

  const { data: listasClientes, isError: listasClientesIsError } =
    useLeerListaClientes();

  const fetchIsError = plantillasIsError || listasClientesIsError;

  const onPlantillaClick = (p: PlantillaCorreoMasivoResumida) => {
    nagivate(`/comunicaciones/correos_masivos/${p.id}`);
  };

  const onCrearPlantilla = (idPlantilla: string) => {
    nagivate(`/comunicaciones/correos_masivos/${idPlantilla}`);
  };

  const onEnviarPlantilla = () => {
    redirigirAListado();
  };

  const redirigirAListado = () => {
    nagivate("/comunicaciones/correos_masivos");
  };

  if (plantillasIsLoading) {
    return <LoadingScreen />;
  }

  if (fetchIsError) {
    return <ServerErrorModal />;
  }
  return (
    <div className="row">
      <section className="col-3">
        <Button className="mb-2" onClick={redirigirAListado}>
          Nuevo
          <AddIcon sx={{ fontSize: 20 }} />
        </Button>
        <ListaPlantillas
          plantillas={plantillas || []}
          onPlantillaClick={onPlantillaClick}
        />
      </section>
      <section className="col-9">
        {!!idPlantilla ? (
          <Plantilla
            idPlantilla={idPlantilla}
            listasClientes={listasClientes || []}
          />
        ) : (
          <NuevoCorreoMasivo
            onGuardar={onCrearPlantilla}
            onEnviar={onEnviarPlantilla}
            listasClientes={listasClientes || []}
          />
        )}
      </section>
    </div>
  );
};
